import React from 'react'
import FormCheckbox from 'components/forms/bases/FormCheckbox'
import { updateObject } from 'helpers/objectHelpers'
import FormSlider from 'components/forms/FormSlider'
import FormSelect from 'components/forms/bases/FormSelect'

const ImageSettings = ({
  onRerender = () => {},
  valueSettings,
  valueSettings: {
    isZoomWhenHovered,
  },
  valueStyles,
  valueStyles: {
    layout: {
      height,
      objectFit,
      objectPositionX,
      objectPositionY,
      verticalImageAlign,
    } = {},
  },
  onChangeSettings,
  onChangeStyle,
}) => {
  const handleChange = (val, key) => {
    return onChangeSettings(updateObject(valueSettings, { [key]: val }))
  }
  const handleStyleChange = (val, key) => {
    if (key === 'objectFit') {
      // props from accordion
      // to recalculate height
      onRerender()
    }
    return onChangeStyle(updateObject(valueStyles, {
      layout: updateObject(valueStyles.layout, {
        [key]: val,
        ...key === 'objectFit' && {
          objectPositionX: 50,
          objectPositionY: 50,
          verticalImageAlign: '',
        },
      }),
    }))
  }
  return (
    <div>
      <FormCheckbox
        label="is zoom when hovered"
        value={isZoomWhenHovered}
        onChange={(val) => handleChange(val, 'isZoomWhenHovered')}
      />
      {(!objectFit || objectFit === '-') && (
        <FormSelect
          label="Vertical Image Alignment"
          options={[
            { label: 'Top Left', value: 'topLeft' },
            { label: 'Top Right', value: 'topRight' },
            { label: 'Center', value: 'center' },
            { label: 'Bottom Left', value: 'bottomLeft' },
            { label: 'Bottom Right', value: 'bottomRight' },
          ]}
          value={verticalImageAlign}
          onChange={(val) => handleStyleChange(val, 'verticalImageAlign')}
        />
      )}
      <FormSelect
        label="Image display style"
        options={
          [
            { label: 'Fill', value: 'fill' },
            { label: 'Contain', value: 'contain' },
            { label: 'Cover', value: 'cover' },
            { label: 'No style', value: '-' },
          ]
        }
        value={objectFit}
        onChange={(val) => handleStyleChange(val, 'objectFit')}
      />
      {(objectFit === 'cover' || objectFit === 'contain') && (
        <FormSlider
          renderLabel={(x) => `Position-X ( ${x}%)`}
          value={objectPositionX >= 0 ? objectPositionX : 50}
          onChange={(val) => handleStyleChange(val, 'objectPositionX')}
        />
      )}
      {(objectFit === 'cover' || objectFit === 'contain') && (
        <FormSlider
          renderLabel={(x) => `Position-Y ( ${x}%)`}
          value={objectPositionY >= 0 ? objectPositionY : 50}
          onChange={(val) => handleStyleChange(val, 'objectPositionY')}
        />
      )}
    </div>
  )
}

ImageSettings.propTypes = {}
ImageSettings.defaultProps = {}

export default ImageSettings



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/image/ImageSettings.js